"use client";
import { HTMLProps } from "react";
import Link from "next/link";
import { cn } from "@/utils/helpers";
import { getLang } from "@/utils/selectors";
import Divider from "@/components/common/Divider";
import SvgLogoStanford from "@/components/common/Svg/components/SvgLogoStanford";
import SvgLogoSite from "@/components/common/Svg/components/SvgLogoSite";
import styles from "./Branding.module.css";

export interface BrandingProps extends HTMLProps<HTMLDivElement> {}

export default function Branding({
	className
} : BrandingProps) {

	return (
		<div
			className={cn(
				styles.Branding,
				className
			)}
		>
			<Link
				href="/"
				className={styles.BrandingLink}
			>
				<SvgLogoStanford
					title={getLang("site", "stanford", "title", "full")}
					className={styles.BrandingStanford}
				/>
				<Divider
					className={styles.BrandingDivider}
				/>
				<SvgLogoSite
					title={getLang("site", "title")}
					className={styles.BrandingSite}
				/>
			</Link>
		</div>
	);
}